import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=2ab4fbc4&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=2ab4fbc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports